module.exports = __webpack_public_path__ + "static/media/gim5.442e7a6e.jpg";